module.exports = __webpack_public_path__ + "static/Barlow-Bold-6b5dd6ff8b4448818052805809d19fc0.woff2";